import React from 'react';

import content from '../../../assets/images/content.svg';
import { CURRENCIES } from '../../../constants/currenciesConstants';
import { numberWithCommas } from '../../../helpers/commonHelper';

import styles from './MonetaryRewardsPill.module.scss';

const MonetaryRewardsPill = ({ monetaryReward, currencyId, useCommas = false }) => (
  <div className={styles.mainContainer}>
    <div className={styles.iconContainer}>
      <img className={styles.iconStyles} src={content} alt={content} />
    </div>

    {monetaryReward && (
      <div className={styles.textContainer}>
        {CURRENCIES[currencyId]}
        {useCommas ? numberWithCommas(monetaryReward) : monetaryReward}
      </div>
    )}
  </div>
);

export default MonetaryRewardsPill;
